import ReactTooltip from "react-tooltip";
import styled, { css } from "styled-components";

type InfoTextContainerProps = {
  isLarge: boolean;
};

export const InfoTextContainer = styled.div<InfoTextContainerProps>`
  margin-bottom: 0.9rem;

  &.skeleton {
    width: 100%;
  }

  svg {
    path {
      stroke: var(--grey-100);
    }
  }

  > div {
    display: flex;
    flex-direction: row;

    &.body {
      > div {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 25px;
        height: 25px;
        background-color: var(--black-300);
        padding: 0.3rem;
        border-radius: 4px;
        margin-right: 0.7rem;
      }

      &.skeleton {
        span {
          width: 100%;
        }
      }
    }
  }

  &:last-child {
    margin-bottom: 0;
  }

  p {
    font-family: Inter;
    font-size: 13px;
    color: #b8b8b8;

    margin-bottom: 4px;
  }

  &.skeleton {
    > span {
      width: 100%;
    }
  }

  span {
    font-family: Inter, sans-serif;
    font-weight: 400;
    color: var(--white);
    font-size: 14px;
  }

  .iconedText {
    > span {
      margin-top: 0.2rem;
    }
  }

  ${({ isLarge }) =>
    isLarge &&
    css`
      span {
        font-size: 20px;
        font-weight: 500;
      }
    `}
`;

export const ColumnHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  &.skeleton {
    span {
      width: 100%;
    }
  }

  span {
    font-size: 13px;
    font-family: DM Sans;

    margin-left: 0.6rem;
    color: var(--grey-100);
  }

  svg {
    path {
      stroke: var(--primary);
    }
  }

  .column-header-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 4px;
    padding: 0.45rem;
    background-color: var(--black-100);
  }
`;

export const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 99%;
  min-height: 400px;
  background: var(--black-200);
  border-radius: 4px;
  padding: 1.5rem;
  margin: 3rem 0rem;
  &:first-of-type {
    margin-top:1.26rem;
  }

  .container {
    display: flex;
    flex-direction: row;
    height: 100%;
  }

  .statusTape {
    background: var(--primary);
    width: 10px;
    height: 302px;
    border-radius: 1rem;
  }

  .lateStatusTape {
    background: rgb(177, 18, 18);
    height: 302px;
    width: 10px;
    border-radius: 1rem;
  }

  .column {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    border-right: 1px solid rgba(82, 82, 82, 0.32);
    padding: 0px 24px;
    flex: 1;

    &:last-child {
      flex: none;
      border-right: 0;
      width: 250px;
      align-items: unset;
      padding-right: 0px;
    }

    article {
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      width: 100%;

      margin-top: 1.5rem;

      padding-bottom: 1.5rem;
    }

    &.skeleton {
      > div {
        width: 100%;
      }
    }
  }

  .customerBeneficiary {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    margin: 0 24px 0 24px;
    height: 100%;
    flex: 1;

    article {
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      p {
        font-size: 14px;
        color: #b8b8b8;
      }

      h3 {
        font-size: 16px;
        color: #ebebeb;
        text-overflow: ellipsis !important;
      }
    }
  }

  .pr-status-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 0.5rem;

    span {
      font-size: 14px;
      color: var(--grey-100);
    }
  }

  .pr-status-hover-cards {
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 0.5rem;
    margin-bottom: 0.5rem;
  }

  .address {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    height: 100%;
    border-left: 2px solid rgba(82, 82, 82, 0.52);
    padding-left: 1.5rem;
    flex: 1;

    article {
      p {
        display: flex;
        align-items: center;
      }
    }

    h2 {
      margin: 10px 0 10px 0;
      font-size: 14px;
      color: #b8b8b8;
    }
  }

  .service {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    text-align: left;
    padding-top: 1rem;

    div {
      p {
        margin-bottom: 1rem;
      }

      span {
        width: 120px;
        background: var(--primary);
        text-align: center;
      }
    }

    .lastP {
      font-size: 0.8rem;
    }
  }

  .additionalInfo {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    text-align: left;
    border-left: 2px solid rgba(82, 82, 82, 0.52);
    padding-left: 1rem;
    flex: 1;

    p {
      display: flex;
      align-items: center;
      text-align: left;
      width: 100%;
      font-size: 14px;
      line-height: 22px;

      img {
        margin-right: 5px;
        width: 15px;
        height: 15px;
      }
    }
  }

  .options {
    height: 100%;
    display: flex;
    justify-content: space-between;
    border-left: 2px solid rgba(82, 82, 82, 0.52);
    padding-left: 1rem;
    margin-left: 1rem;

    .buttons {
      margin-top: 1rem;
    }

    button {
      width: 226px;
      height: 42px;
      margin-bottom: 10px;
      background: #2e2d2d !important;
      color: white;
      font-size: 14px;
      color: #ebebeb;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
`;

export const CardHeader = styled.header`
  display: flex;
  flex-direction: row;
  height: 100%;
  justify-content: space-between;

  .favoriteIcon {
    position: absolute;
    top: -2.2rem;
    left: -0.2rem;
    background: none;
  }

  .protocol {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    background: var(--black-300);
    width: 280px;
    border-radius: 4px;

    .infoColumn {
      width: 280px;
      height: 100%;
      margin-left: 10px;
      padding: 1rem;

      .infoColumnHeader {
        display: flex;
        flex-direction: row;
        text-align: left;
        align-items: center;

        p {
          font-size: 14px;
          line-height: 22px;
          color: #b8b8b8;
          margin-bottom: 5px;
        }

        img {
          margin-right: 10px;
        }
      }
    }
  }

  strong {
    width: 100%;
    text-align: center;
    font-size: 1.5rem;
  }

  img {
    width: 4rem;
    height: 4rem;
    background: var(--black-100);
    border-radius: 4px;
  }
`;

type PinButtonProps = {
  isActive: boolean;
};

export const PinButton = styled.button<PinButtonProps>`
  border-radius: 4px;
  background: var(--black-400);
  padding: 0.4rem;
  position: absolute;
  top: -1.3rem;
  left: 0.6rem;
  height: 35px;
  width: 35px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    path {
      stroke: var(--primary);
      fill: transparent;
    }
  }

  ${({ isActive }) =>
    isActive &&
    css`
      svg {
        path {
          fill: var(--primary);
          stroke: var(--primary);
        }
      }
    `}

  transition: 0.4s background;

  &:hover {
    background-color: var(--black-300);
  }
`;

export const ProtocolContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: var(--black-400);
  width: 280px;
  min-height: 360px;
  border-radius: 4px;
  padding: 0.8rem;

  .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    margin-bottom: 0.5rem;

    p {
      font-family: Inter;
      color: var(--grey-100);
    }

    span {
      font-family: Inter;
    }

    > div:last-child {
      margin-left: 0.5rem;
    }

    .occurrence-icon {
      background-color: var(--black-100);
      border-radius: 4px;
      padding: 0.85rem;
    }
  }

  .body {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .protocol-id-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    &.skeleton {
      margin-top: 1rem;
    }

    span {
      text-transform: uppercase;
    }

    button {
      display: flex;
      align-items: center;
      justify-content: center;

      width: 35px;
      height: 35px;

      background-color: var(--black-200);

      padding: 0.5rem;

      border-radius: 4px;

      transition: 0.4s background;

      &:hover {
        background-color: var(--black-100);
      }
    }

    svg {
      path {
        stroke: var(--grey-100);
      }
    }
  }
`;

export const ActionsContainer = styled.div`
  display: flex;
  justify-content: flex-start !important;

  article {
    margin-top: 1.3rem;
  }

  button {
    width: 100% !important;
    align-self: stretch;
    height: 42px;
    /* background-color: var(--black-400) !important; */
    margin-bottom: 10px;
    color: white;
    font-size: 14px;
    font-weight: 500;
    transition: 0.4s background;

    &:last-child {
      margin-bottom: 0;
    }
  }

  @media (max-width: 1366px) {
    display: none !important;
    visibility: collapse;
  }
`;

export const Footer = styled.footer`
  display: flex;
  flex-direction: row;
  width: 20%;
  padding: 1.1rem 0rem 0rem;
  border-top: 1px solid rgba(82, 82, 82, 0.32);
  display: none;
  visibility: collapse;

  button {
    width: 100%;

    padding: 1.5rem 0rem;

    font-family: Inter;
    font-size: 0.9rem;
    font-weight: 600;

    transition: brightness 0.4s;


    &:first-of-type {
      width: 56.93%;

      font-weight: 500;
      margin-right: 1rem;

      &:hover {
        background-color: lighten(#2e2d2d, 5%);
      }
    }
  }

  @media (max-width: 1366px) {
    display: flex;
    flex-direction: row !important;
    visibility: visible;
    width: 100%;
    margin-top: 1.3rem;

    > div {
      width: 100%;
    }

    article {
      display: flex;
      flex-direction: row;
      margin-top: 0.5rem;
    }

    button {
      width: 100% !important;
      align-self: stretch !important;
      height: 36px;
      margin-right: 0.5rem;
      color: white;
      font-size: 13px;
      font-weight: 500;
      transition: 0.4s background;

      &:last-child {
        margin-right: 0;
      }
    }
  }
`;

export const AttendantBadge = styled.div`
  display: flex;
  flex-direction: row;
  padding: 9px 12px;
  background: var(--darker-primary);
  border-radius: 10px;
  color: var(--primary);
  font-size: 12px;
  font-family: Inter;
`;

type StatusBorderVariant = "isLate" | "notPr" | "isCancelled"

type StatusBorderProps = {
  variants?: StatusBorderVariant;
};

const getStatusBorderVariant = (variant?: StatusBorderVariant) => {
  switch (variant) {
    case 'isCancelled':
      return css`
        background-color: var(--red);
      `;
    case 'isLate':
      return css`
        background-color: red;
      `;
    case 'notPr':
      return css`
        background-color: grey;
      `
    default:
      return css`
        background-color: var(--primary);
      `
  }
}

export const StatusBorder = styled.div<StatusBorderProps>`
  width: 10px;
  height: 100%;
  margin-right: 0.4rem;
  border-radius: 4px;
  ${({ variants }) => getStatusBorderVariant(variants)}
`;

export const StyledReactTooltip = styled(ReactTooltip)`
  color: var(--white);
  font-family: DM Sans;
  font-size: 0.85rem !important;
  width: auto;
  opacity: 1 !important;
  text-align: center;

  span {
    text-decoration: underline;
}
`

export const ManualBadgeContainer = styled.div`
  border-radius: 4px;
  padding: 0.6rem;
  background-color: yellow;
  margin-bottom: 0.8rem;
  cursor: pointer;

  span {
    font-family: DM Sans, sans-serif;
    font-size: 0.8rem;
    text-transform: uppercase;
    text-align: center;
    color: var(--black-100);
    font-weight: 600;
  }
`;

export const Badge = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  position: relative;
  margin-top: 0.4rem;
  margin-bottom: 0.8rem;
  width: 100%;
  padding: 0.5625rem 0.75rem;
  border-radius: 6.25rem;
  font-size: 0.75rem;
  font-family: DM Sans, sans-serif;
  font-weight: 400;
  min-height: 2rem;

  &.andamento {
    color: white;
    background: rgba(235, 235, 235, 0.1);
  }

  &.aguardando {
    color: var(--primary);
    background: var(--darker-primary);
  }

  &.finalizado {
    color: var(--green);
    background: rgba(71, 212, 68, 0.1);
  }

  &.aguardando_cancelamento {
    color: var(--red);
    font-weight: 500;
    background-color: rgba(204, 57, 57, 0.16);
  }
`;

export const TimeBadge = styled.div`
  margin-bottom: 1.1rem;
  padding: 0.5rem 0.8rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  border-radius: 20px;
  font-family: Inter, sans-serif;

  &.andamento {
    color: white;
    background: rgba(235, 235, 235, 0.1);
  }

  &.aguardando {
    color: var(--primary);
    background: var(--darker-primary);
  }

  &.finalizado {
    color: var(--green);
    background: rgba(71, 212, 68, 0.1);
  }

  &.late,
  &.complete,
  &.free {
    justify-content: center;
  }

  &.late {
    color: var(--red);
    background-color: rgba(204, 57, 57, 0.16);
  }

  &.free {
    color: var(--primary);
    background: var(--darker-primary);
  }

  &.complete {
    color: var(--green);
    background-color: rgba(99, 204, 57, 0.16);
  }

  p,
  span {
    font-size: 0.8rem;
  }

  p {
    margin: 0;
  }

  span {
    text-align: center;
    display: flex;
    align-items: center;
  }

  > div {
    display: flex;
    flex-direction: row;
    align-items: center;

    @keyframes flickerAnimation {
      0% {
        opacity: 1;
      }

      50% {
        opacity: 0;
      }

      100% {
        opacity: 1;
      }
    }

    @-o-keyframes flickerAnimation {
      0% {
        opacity: 1;
      }

      50% {
        opacity: 0;
      }

      100% {
        opacity: 1;
      }
    }

    @-moz-keyframes flickerAnimation {
      0% {
        opacity: 1;
      }

      50% {
        opacity: 0;
      }

      100% {
        opacity: 1;
      }
    }

    @-webkit-keyframes flickerAnimation {
      0% {
        opacity: 1;
      }

      50% {
        opacity: 0;
      }

      100% {
        opacity: 1;
      }
    }

    .circle {
      width: 10px;
      height: 10px;
      border-radius: 100%;

      margin-right: 0.5rem;

      background: var(--red);

      -webkit-animation: flickerAnimation 2.5s infinite;
      -moz-animation: flickerAnimation 2.5s infinite;
      -o-animation: flickerAnimation 2.5s infinite;
      animation: flickerAnimation 2.5s infinite;
    }
  }
`;

type AlertBadgeProps = {
  isRejected: boolean;
};

export const AlertBadge = styled.div<AlertBadgeProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -10px;
  right: -10px;
  padding: 0.33rem;
  width: 24px;
  height: 24px;
  background: none;
  border-radius: 100px;
  cursor: pointer;

  button {
    background: none;
  }

  span {
    font-size: 1rem;
    color: var(--white);
    font-weight: 500;
  }

  background: ${({ isRejected }) => isRejected ? "var(--black-100)" : 'transparent'};
`;

type IdleContainerProps = {
  isStopped: boolean;
};

export const IdleContainer = styled.div<IdleContainerProps>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.8rem;
  font-size: 0.85rem;
  font-family: DM Sans;
  text-align: center;
  margin-top: 1rem;
  border: 1px solid rgba(82, 82, 82, 0.32);
  border-radius: 4px;

  ${({ isStopped }) =>
    isStopped &&
    css`
      border: 1px solid var(--red);
      color: var(--red);
      background-color: rgba(204, 57, 57, 0.16);
    `}
`;


